import React from "react";
import { logger } from "../lib/logger";

const openExternal = () => {
  const url = window.location.href;
  if (/android/i.test(navigator.userAgent)) {
    window.location.href = `intent://${url.replace(/^https?:\/\//, "")}#Intent;scheme=https;end`;
  } else {
    window.open(url, "_blank");
  }
};

export class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    logger.error("App crashed:", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const btn = "px-6 py-3 text-xs tracking-[0.15em] uppercase";
    return (
      <div data-testid="app-error-fallback" className="min-h-screen bg-[#0B0A08] text-[#E8DCC4] flex flex-col items-center justify-center text-center px-6 gap-4">
        <div className="text-2xl tracking-[0.35em] font-serif">OMR PERFUMER</div>
        <p className="text-sm text-[#8A857D]">Something went wrong · حدث خطأ أثناء التحميل</p>
        <button data-testid="app-error-retry" className={`${btn} bg-[#C9A26B] text-[#0B0A08]`} onClick={() => window.location.reload()}>
          إعادة المحاولة · Retry
        </button>
        <button data-testid="app-error-open-browser" className={`${btn} border border-[#C9A26B] text-[#C9A26B]`} onClick={openExternal}>
          افتح في المتصفح · Open in browser
        </button>
      </div>
    );
  }
}
